/* eslint-disable @typescript-eslint/no-misused-promises */

import he from 'he';

import { useForm } from 'react-hook-form';
import { useVideoLessonMutation } from '@shared/api';

import { Locale } from '@shared/libs';
import { Button, Input } from '@shared/ui';
import styles from './video-lesson.module.css';

type TForm = {
  title: string;
  email: string;
};

type TProps = {
  onClose?: () => void;
  locale: Locale;
  title: string;
};

export const Modal = ({ locale, title, onClose }: TProps) => {
  const { register, handleSubmit } = useForm<TForm>({ defaultValues: { title } });

  const { mutate, isError, isSuccess, isLoading } = useVideoLessonMutation();

  const submit = (form: TForm) => {
    mutate(form);
  };

  return (
    <form onSubmit={handleSubmit(submit)}>
      {isSuccess ? (
        <>
          <p className={styles.modalText}>
            {he.decode(locale.NOTE_VIDEO_LESSON_FORM_SUCCESS || 'NOTE_VIDEO_LESSON_FORM_SUCCESS')}
          </p>
          <div className={styles.modalBtnWrap}>
            <Button color="green" onClick={() => onClose?.()}>
              {he.decode(
                locale.NOTE_VIDEO_LESSON_FORM_SUCCESS_BTN || 'NOTE_VIDEO_LESSON_FORM_SUCCESS_BTN',
              )}
            </Button>
          </div>
        </>
      ) : (
        <>
          <p className={styles.modalText}>
            {he.decode(locale.NOTE_VIDEO_LESSON_FORM_TEXT || 'NOTE_VIDEO_LESSON_FORM_TEXT')}
          </p>
          <Input
            placeholder={locale.NOTE_VIDEO_LESSON_FORM_MAIL || 'NOTE_VIDEO_LESSON_FORM_MAIL'}
            autoComplete="email"
            label={locale.NOTE_VIDEO_LESSON_FORM_MAIL || 'NOTE_VIDEO_LESSON_FORM_MAIL'}
            formGroupClassName={styles.formGroup}
            className={styles.input}
            {...register('email', { required: true })}
          />

          {isError && (
            <p className={styles.error}>
              {he.decode(locale.NOTE_VIDEO_LESSON_FORM_ERROR || 'NOTE_VIDEO_LESSON_FORM_ERROR')}
            </p>
          )}

          <div className={styles.modalBtnWrap}>
            <Button color="green" type="submit" loading={isLoading}>
              {he.decode(locale.NOTE_VIDEO_LESSON_FORM_BTN || 'NOTE_VIDEO_LESSON_FORM_BTN')}
            </Button>
          </div>
        </>
      )}
    </form>
  );
};
